module.exports = __webpack_public_path__ + "img/prayerhands.fa479bde.png";